<template>
<div class="data-time-switch">
  <div class="data-time-switch-header">时间</div>
  <div class="divider"></div>
  <ul ref="data-time-switch-list" class="data-time-switch-list">
    <li
      v-for="option in options"
      :key="option.value"
      :class="{
        active: option.value === value
      }"
      @click="onclick(option)"
    >{{option.label}}</li>
  </ul>
</div>
</template>

<script>
export default {
  name: 'DataTimeSwitch',
  props: {
    value: {
      required: true
    },
    options: {
      required: true,
      type: Array
    }
  },
  methods: {
    onclick (option) {
      const {value} = option

      if (value === this.value) {
        return
      }

      this.$emit('input', value)
      this.$emit('change', value)
      this.isSelfChange = true
    }
  },
  watch: {
    value () {
      // if (this.isSelfChange) {
      //   this.isSelfChange = false
      //   return
      // }

      setTimeout(() => {
        const activeLi = this.$refs['data-time-switch-list'].querySelector('li.active')

        if (activeLi) {
          activeLi.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          })
        }
      }, 0)
    }
  }
}
</script>

<style lang="scss">
.data-time-switch {
  --header-height: 2rem;

  display: grid;
  grid-template-rows: var(--header-height) 1px auto;
  width: 150px;
  border: 1px solid #ebeef5;

  > * {
    min: {
      width: 0;
      height: 0;
    };
  }

  > .data-time-switch-header {
    padding: 0 10px;
    line-height: var(--header-height);
    background-color: #f9f9f9;
    font-weight: 700;
  }

  > .divider {
    background-color: #ebeef5;
  }

  > .data-time-switch-list {
    margin: 0;
    padding: 3px 0;
    line-height: 2rem;
    color: #303133;
    list-style: none;
    overflow: auto;

    > li {
      font-size: 14px;
      padding: 0 10px;
      cursor: pointer;

      &:hover {
        background-color: #F5F7FA;
      }

      &.active {
        color: #409EFF;
        background-color: #ecf5ff;
        cursor: default;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DataTimeSwitch/index.vue